exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news_container{margin-bottom:15px;margin-top:15px;cursor:pointer}.news_icon{padding-left:10px;padding-top:5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.news_ad,.news_icon{display:-webkit-box;display:-ms-flexbox;display:flex}.news_ad{-webkit-box-shadow:0 0 0 1px #15b76c;box-shadow:0 0 0 1px #15b76c;border-radius:12px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.news_left{width:100%}.news_title{color:#000;margin-top:6px;margin-left:10px}.news_subtitle{margin-left:10px;color:#15b76c;text-transform:none}.news_btn{background-color:transparent;color:#15b76c;padding:1.05rem}", ""]);

// exports
